const apiUrls = {
	registerFixed: {
		url: '/hybris/selfcare/b2c/v1/register/verifycustomer',
		open: true
	},
	registerMobile: {
		url: '/hybris/selfcare/b2c/v1/register/verifyotpcode',
		open: true
	},
	checkCredentials: {
		url: '/hybris/selfcare/b2c/v1/register/checkcredentials',
		open: true
	},
	confirmPassword: {
		url: '/hybris/selfcare/b2c/v1/register/confirmpassword',
		open: true
	},
	getConsentUnAuth: {
		url: '/hybris/selfcare/b2c/v1/consenttemplates?consentTemplateId={consentTemplateId}',
		open: true
	},
	checkEmail: {
		url: '/hybris/selfcare/b2c/v1/register/isemailavailable?email={email}',
		open: true
	},
	createAccount: {
		url: '/hybris/selfcare/b2c/v1/register/credentials/add',
		open: true
	},
	resendEmail: {
		url: '/hybris/selfcare/b2c/v1/register/resendemail',
		open: true
	},
	sendSms: {
		url: '/hybris/selfcare/b2c/v1/register/sendotpcode',
		open: true
	},
	forgottenPassword: {
		url: '/selfcare/b2c/user/password/forgottenpassword',
		open: true
	},
	resendForgottenPassword: {
		url: '/hybris/selfcare/b2c/v1/user/password/forgottenpassword',
		open: true
	},
	newPassword: {
		url: '/hybris/selfcare/b2c/v1/user/password/reset',
		open: true
	},
	authorize: {
		url: '/selfcare/b2c/users/authorize',
		open: true
	},
	authorizeTrusted: {
		url: '/selfcare/b2c/users/trusted/authorize',
		open: true
	},
	getToken: {
		url: '/selfcare/b2c/user/token',
		open: true
	},
	userProfileDetails: {
		url: '/hybris/selfcare/b2c/v1/user/info'
	},
	logout: {
		url: '/selfcare/b2c/user/logout'
	},
	deleteAccount: {
		url: '/hybris/selfcare/b2c/v1/users/{userId}'
	},
	loginBanner: {
		url: '/hybris/selfcare/b2c/v1/banner/login',
		open: true
	},
	changeEmail: {
		url: '/hybris/selfcare/b2c/v1/user/login'
	},
	changeEmailResend: {
		url: '/hybris/selfcare/b2c/v1/registration/resendemail'
	},
	changePassword: {
		url: '/hybris/selfcare/b2c/v1/password'
	},
	unlinkAccount: {
		url: '/hybris/selfcare/b2c/v1/service/connection/{customerId}'
	},
	sendSmsService: {
		url: '/hybris/selfcare/b2c/v1/user/sendotpcode'
	},
	checkMobileService: {
		url: '/hybris/selfcare/b2c/v1/user/verifyotpcode'
	},
	checkFixedService: {
		url: '/hybris/selfcare/b2c/v1/user/service/connection/checkfixed?subscriberCode={subscriberCode}&referenceNumber={referenceNumber}'
	},
	checkCredentialsService: {
		url: '/hybris/selfcare/b2c/v1/checkcredentials'
	},
	connectServiceMobile: {
		url: '/hybris/selfcare/b2c/v1/user/service/connection/mobile'
	},
	connectServiceFixed: {
		url: '/hybris/selfcare/b2c/v1/user/service/connection/fixed'
	},
	getNavigation: {
		url: '/hybris/selfcare/b2c/v1/user/navigation'
	},
	getPrepaidTariffs: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffs/prepaid?subscriberIdentity={subscriberIdentity}'
	},
	activePrepaidTariff: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffs/activate'
	},
	getTariffPlanResources: {
		url: '/hybris/selfcare/b2c/v1/customer/services/details?subscriberIdentity={subscriberIdentity}'
	},
	getCustomerHeader: {
		url: '/hybris/selfcare/b2c/v1/customer/services/header?subscriberIdentity={subscriberIdentity}'
	},
	deactivateTariff: {
		url: '/hybris/selfcare/b2c/v1/services/tariffplans'
	},
	getAvailableTariffPlans: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffsPlans/prepaid?subscriberIdentity={subscriberIdentity}'
	},
	activateTariffPlan: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffplans/activate'
	},
	activateGrace: {
		url: '/hybris/selfcare/b2c/v1/customer/services/graceperiod'
	},
	getTariffOptions: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffoptions?subscriberIdentity={subscriberIdentity}'
	},
	activateTariffOption: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffoptions/activate'
	},
	deactivateTariffOption: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffoptions/deactivate'
	},
	getAdditionalServices: {
		url: '/hybris/selfcare/b2c/v1/services/additionalservices?subscriberIdentity={subscriberIdentity}'
	},
	toggleAdditionalServiceStatus: {
		url: '/hybris/selfcare/b2c/v1/services/update'
	},
	getTopups: {
		url: '/hybris/selfcare/b2c/v1/user/topup'
	},
	getAutomaticTopups: {
		url: '/hybris/selfcare/b2c/v1/user/topup/automatic?subscriberIdentity={subscriberIdentity}'
	},
	activateTopup: {
		url: '/hybris/selfcare/b2c/v1/user/topup/activate'
	},
	deactivateAutoTopup: {
		url: '/hybris/selfcare/b2c/v1/user/topup/automatic/deactivate?code={code}&subscriptionIdentity={subscriptionIdentity}'
	},
	transferCreditTopup: {
		url: '/hybris/selfcare/b2c/v1/user/topup/prepaid/transfercredit'
	},
	changeLoginVerify: {
		url: '/hybris/selfcare/b2c/v1/changelogin/verify',
		open: true
	},
	getInternetTariffs: {
		url: '/hybris/selfcare/b2c/v1/customer/adsl/tariffs?subscriberIdentity={subscriberIdentity}'
	},
	activateInternetTariff: {
		url: '/hybris/selfcare/b2c/v1/customer/adsl/tariff/activate'
	},
	getPostpaidTariffs: {
		url: '/hybris/selfcare/b2c/v1/customer/postpaid/tariffs?subscriberIdentity={subscriberIdentity}'
	},
	activatePostpaidTariff: {
		url: '/hybris/selfcare/b2c/v1/customer/postpaid/tariff/activate'
	},
	getTariffAddons: {
		url: '/hybris/selfcare/b2c/v1/customer/services/addons?subscriberIdentity={subscriberIdentity}'
	},
	addFavouriteNumber: {
		url: '/hybris/selfcare/b2c/v1/customer/services/fnfplus'
	},
	removeFavouriteNumber: {
		url: '/hybris/selfcare/b2c/v1/customer/services/fnfplus?subscriberIdentity={subscriberIdentity}'
	},
	addDearestNumber: {
		url: '/hybris/selfcare/b2c/v1/customer/services/fnfextra'
	},
	removeDearestNumber: {
		url: '/hybris/selfcare/b2c/v1/customer/services/fnfextra?subscriberIdentity={subscriberIdentity}'
	},
	getTariffOption: {
		url: '/hybris/selfcare/b2c/v1/customer/services/tariffoptions/details?subscriberIdentity={subscriberIdentity}&code={code}'
	},
	addFriendNumber: {
		url: '/hybris/selfcare/b2c/v1/customer/services/fnf/add'
	},
	removeFriendNumber: {
		url: '/hybris/selfcare/b2c/v1/customer/services/fnf/remove?subscriberIdentity={subscriberIdentity}&friendMsisdn={friendMsisdn}'
	},
	editFriendNumber: {
		url: '/hybris/selfcare/b2c/v1/customer/services/fnf/edit'
	},
	getStbList: {
		url: '/hybris/selfcare/b2c/v1/customer/iptv/stb?subscriberIdentity={subscriberIdentity}'
	},
	addStbDevice: {
		url: '/hybris/selfcare/b2c/v1/customer/iptv/stb'
	},
	removeStbDevice: {
		url: '/hybris/selfcare/b2c/v1/customer/iptv/stb?subscriberIdentity={subscriberIdentity}'
	},
	getStbListMSAT: {
		url: '/hybris/selfcare/b2c/v1/customer/msat/addons/stb?subscriberIdentity={subscriberIdentity}'
	},
	addStbDeviceMSAT: {
		url: '/hybris/selfcare/b2c/v1/customer/msat/stb/add'
	},
	removeStbDeviceMSAT: {
		url: '/hybris/selfcare/b2c/v1/customer/msat/stb/remove?subscriberIdentity={subscriberIdentity}'
	},
	getListOfChannels: {
		url: '/hybris/selfcare/b2c/v1/customer/tv/channels?subscriberIdentity={subscriberIdentity}',
	},
	getListOfUnpaidBills: {
		url: '/hybris/selfcare/b2c/v1/bills/unpaid',
	},
	getOldBills: {
		url: '/hybris/selfcare/b2c/v1/bills?billingAccountId={billingAccountId}&subscriberIdentity={subscriberIdentity}',
	},
	downloadBillPdf: {
		url: '/hybris/selfcare/b2c/v1/bills/pdf?invoiceNumber={invoiceNumber}&authorization={token}&billingAccountId={billingAccountId}'
	},
	downloadBillTrustedPdf: {
		url: '/hybris/selfcare/b2c/v1/bills/pdf?invoiceNumber={invoiceNumber}&authorization={token}&billingAccountId={billingAccountId}&userId={userId}'
	},
	sendEmail: {
		url: '/hybris/selfcare/b2c/v1/bills/email'
	},
	getEBills: {
		url: '/hybris/selfcare/b2c/v1/ebill',
	},
	changeEBillStatus: {
		url: '/hybris/selfcare/b2c/v1/ebill/changestatus',
	},
	requestToCreateTvToGoAccount: {
		url: '/hybris/selfcare/b2c/v1/customer/tv-to-go/requestAccount',
	},
	getTvToGoDetails: {
		url: '/hybris/selfcare/b2c/v1/customer/tv-to-go/information?subscriberIdentity={subscriberIdentity}',
	},
	changeTvPassword: {
		url: '/hybris/selfcare/b2c/v1/customer/tv-to-go/changePassword',
	},
	deleteTvAccount: {
		url: '/hybris/selfcare/b2c/v1/customer/tv-to-go/deleteaccount?subscriberIdentity={subscriberIdentity}',
	},
	deleteTvDevice: {
		url: '/hybris/selfcare/b2c/v1/customer/tv-to-go/removeDevice?subscribedIdentity={subscribedIdentity}&mac={mac}&deviceId={deviceId}',
	},
	activateOccasionallyDeactivatedService: {
		url: '/hybris/selfcare/b2c/v1/customer/services/occasionallydeactivated/activate',
	},
	getTvAddons: {
		url: '/hybris/selfcare/b2c/v1/customer/iptv/addons?subscriberIdentity={subscriberIdentity}'
	},
	activateTVAddon: {
		url: '/hybris/selfcare/b2c/v1/customer/{serviceType}/addons/activate'
	},
	deactivateTVAddon: {
		url: '/hybris/selfcare/b2c/v1/customer/{serviceType}/addons/deactivate'
	},
	getAddonChannels: {
		url: '/hybris/selfcare/b2c/v1/customer/{serviceType}/channels?subscriberIdentity={subscriberIdentity}&addonCode={addonCode}'
	},
	getCars: {
		url: '/hybris/selfcare/b2c/v1/parking/cars?subscriberIdentity={subscriberIdentity}'
	},
	addCar: {
		url: '/hybris/selfcare/b2c/v1/parking/addCar'
	},
	removeCar: {
		url: '/hybris/selfcare/b2c/v1/parking/deleteCar?subscriberIdentity={subscriberIdentity}&code={code}'
	},
	payParking: {
		url: '/hybris/selfcare/b2c/v1/parking/pay'
	},
	getAppsNavigation: {
		url: '/hybris/selfcare/b2c/v1/user/apps/page/navigation'
	},
	getWhaleboneUrl: {
		url: '/hybris/selfcare/b2c/v1/user/securenet/redirect'
	},
	getBarringServices: {
		url: '/hybris/selfcare/b2c/v1/barring/services'
	},
	activateBarringConnectedService: {
		url: '/hybris/selfcare/b2c/v1/barring/services/activate'
	},
	getContracts: {
		url: '/hybris/selfcare/b2c/v1/{serviceType}/contracts'
	},
	getAddons: {
		url: '/hybris/selfcare/b2c/v1/{serviceType}/addons?subscriberIdentity={subscriberIdentity}'
	},
	activateAddon: {
		url: '/hybris/selfcare/b2c/v1/{serviceType}/activate'
	},
	deactivateAddon: {
		url: '/hybris/selfcare/b2c/v1/{serviceType}/deactivate'
	},
	changeAddon: {
		url: '/hybris/selfcare/b2c/v1/{serviceType}/change'
	},
	getUserGuide: {
		url: '/hybris/selfcare/b2c/v1/banner/userguide/{serviceType}'
	},
	getPersonalOffer: {
		url: '/hybris/selfcare/b2c/v1/customer/services/personaloffer?subscriberIdentity={subscriberIdentity}'
	},
	activatePersonalOfferProduct: {
		url: '/hybris/selfcare/b2c/v1/customer/services/personaloffer/activate'
	},
	getTvPromoBanner: {
		url: '/hybris/selfcare/b2c/v1/banner/iptv/promo?subscriberIdentity={subscriberIdentity}'
	},
	getHBOBanner: {
		url: '/hybris/selfcare/b2c/v1/banner/hbomax?subscriberIdentity={subscriberIdentity}'
	},
	activateHBOBanner: {
		url: '/hybris/selfcare/b2c/v1/customer/iptv/hbomax/activate'
	},
	sendRequest: {
		url: '/hybris/selfcare/b2c/v1/tickets/{supportType}/create'
	},
	getSupportDetails: {
		url: '/hybris/selfcare/b2c/v1/tickets/{supportType}'
	},
	userEvent: {
		url: '/hybris/selfcare/b2c/v1/customer/services/userevent'
	},
	personalOfferBanner: {
		url: '/hybris/selfcare/b2c/v1/banner/personaloffer/promo?subscriberIdentity={subscriberIdentity}&serviceType={serviceType}'
	},
	getNotifications: {
		url: '/hybris/selfcare/b2c/v1/notifications'
	},
	deleteNotifications: {
		url: '/hybris/selfcare/b2c/v1/notifications/delete'
	},
	readNotification: {
		url: '/hybris/selfcare/b2c/v1/notifications/read'
	},
	banners: {
		url: '/hybris/selfcare/b2c/v1/banner'
	},
	getUnpaidBills: {
		url: '/hybris/selfcare/b2c/v1/bills/status',
	},
	getCentili: {
		url: '/hybris/selfcare/b2c/v1/centili?deviceType={deviceType}',
	},
	getBillsCurrent: {
		url: '/hybris/selfcare/b2c/v1/bills/subscriber/{subscriberIdentity}',
	},
	getOtpCodeTopup: {
		url: '/hybris/selfcare/b2c/v1/user/topup/sendotpcode',
	},
};

export interface ApiUrl {
    url: string;
	open?: boolean
}

export type ApiUrlsType = keyof typeof apiUrls;

export default apiUrls as { [key in ApiUrlsType]: ApiUrl };
